import Immutable from "seamless-immutable";

const initialState = Immutable({});

const DatesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default DatesReducer;
